<template>
	<div class="tc-header-chart">
		<div :style="styleInner" :class="classInner" v-statemachine="sm">
			<div style="height: 24px; position: relative;"
				class="caption white--text primary"
			>
				<div :style="styleCaption">
					<v-btn flat small color="white" @click="onClickPrevDay">&lt; 前日</v-btn>
					<v-btn flat small color="white" @click="onClickShowCalendarDialog">{{ caption }}</v-btn>
					<v-btn flat small color="white" @click="onClickNextDay">翌日 &gt;</v-btn>
				</div>
			</div>
			<div :class="classHoliday" style="height: 24px">
			</div>
			<div style="height: 24px" class="white--text primary lighten-2">
				<div class="label" :style="styleLabelHalf" ></div>
				<div v-for="l in labels"
					:key="l.id"
					class="label"
					:style="styleLabel"
				>
					{{ l.text }}
				</div>
				<div class="label" :style="styleLabelHalf" ></div>
			</div>
			<div style="height: 24px" class="tc-header-chart-background white--text primary lighten-2"
				:class="classBackground"
			>
				<div class="tc-header-chart-now" :style="styleNow"></div>
			</div>
			<transition name="fade" @after-enter="transitionCallback">
				<div v-show="$store.getters['chart/isScrollingToNow']" class="transition-move-to-now"></div>
			</transition>
		</div>
	</div>
</template>
<script>
import { CHART_TICK, strftime } from '../../classes/Const';
import ScheduleTick from '../../classes/ScheduleTick';
import MouseStateMachine from '../../classes/MouseStateMachine';
import MouseState from '../../classes/MouseState';

export default {
	name: 'TCHeaderChart',
	props: [ ],
	data() {
		let state_default = new MouseState({
			down: (e) => {
				let elm = e.target;
				let btn = elm.classList.contains('v-btn') ? elm : elm.closest('.v-btn');
				if (btn)
					return;

				this.$emit('hscroll-start', {
					x: e.pageX,
				});
			},
		});
		return {
			sm: new MouseStateMachine(state_default),
		};
	},
	methods: {
		onClickPrevDay: function() {
			this.$store.dispatch('setCurrentDatePreviousDay');
		},
		onClickNextDay: function() {
			this.$store.dispatch('setCurrentDateNextDay');
		},
		onClickShowCalendarDialog: function() {
			this.$emit('show-calendar');
		},
		transitionCallback: function() {
			this.$store.commit('chart/setScrollingToNow', false);
		},
	},
	computed: {
		labels: function() {
			let list = new Array();
			let offset_hours = this.$store.getters.dateChangeLineOffsetHours;
			let stick = new ScheduleTick({
				code: '197001010000',
			});
			stick.addHours(offset_hours);
			for (let i = 1; i < 24; i++) {
				stick.addHours(1);
				list.push({
					id: i + 1,
					text: stick.strftimeDCL('%H:%M'),
				});
			}

			return list;
		},
		caption: function() {
			let day = this.$store.getters.createDateCurrentBeginningDay;
			return strftime('%Y年%m月%d日(%A)', day);
		},
		styleInner: function() {
			let inner = this.$store.getters['chart/innerWidth'];
			let hscroll = this.$store.getters['chart/hscroll'];
			return {
				position: 'absolute',
				width: inner + 'px',
				left: (- hscroll) + 'px',
			};
		},
		classInner: function() {
			let classes = [];

			if (this.$store.getters['chart/isScrollingToNow'])
				classes.push('transition-move-to-now');

			return classes;
		},
		styleCaption: function() {
			const caption_width = 314;
			let hscroll = this.$store.getters['chart/hscroll'];
			let list = this.$store.getters['chart/listWidth'];
			let outer = this.$store.getters['windowWidth'];
			
			return {
				position: 'absolute',
				left: (hscroll + (outer - list - caption_width) / 2) + 'px',
				width: caption_width + 'px',
			};
		},
		styleLabel: function() {
			let tick = this.$store.getters['chart/chartTick'];
			return {
				width: (60 / tick.minutes * tick.size) + 'px',
			};
		},
		styleLabelHalf: function() {
			let tick = this.$store.getters['chart/chartTick'];
			return {
				width: (30 / tick.minutes * tick.size) + 'px',
			};
		},
		classHoliday: function() {
			return [ 'white--text', 'primary' ];
		},
		classBackground: function() {
			let classes = [];
			let tick = this.$store.getters['chart/chartTick'];

			if (tick.id === CHART_TICK.SM.id)
				classes.push('tc-chart-tick-sm');
			else if (tick.id === CHART_TICK.MD.id)
				classes.push('tc-chart-tick-md');
			else if (tick.id === CHART_TICK.BG.id)
				classes.push('tc-chart-tick-bg');

			return classes;
		},
		styleNow: function() {
			let position = this.$store.getters['chart/chartOffsetNowLine'] - 9;

			return {
				display: (position >= 0) ? 'block' : 'none',
				left: position + 'px',
			};
		},
	},
};
</script>
<style>
	.tc-header-chart {
		position: relative;
		width: 100%;
		height: 96px;
		overflow: hidden;
	}

	.tc-header-chart .caption .v-btn {
		height: 24px;
		margin: 0;
	}

	.tc-header-chart .label {
		display: inline-block;
		text-align: center;
	}

	.tc-header-chart-now {
		position: absolute;
		left: 0;
		width: 19px;
		height: 24px;
		background-image: url("../../assets/tc-header-chart-now.png");
	}

	.tc-header-chart-background {
		background-repeat: repeat;
	}
	.tc-header-chart-background.tc-chart-tick-sm {
		background-image: url("../../assets/tc-header-chart-background-sm.png");
	}
	.tc-header-chart-background.tc-chart-tick-md {
		background-image: url("../../assets/tc-header-chart-background-md.png");
	}
	.tc-header-chart-background.tc-chart-tick-bg {
		background-image: url("../../assets/tc-header-chart-background-bg.png");
	}
</style>
